import React from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import "./SectionHeader.component.scss";

export interface SectionHeaderProps {
    chosenType: string | null;
    onSelectItem: (selectedItem: string[]) => void;
}

const SectionHeader = (props: SectionHeaderProps) => {
    return (
        <div
            className="header-container button-selector"
            id="configurations-header"
        >
            <label className="label">
                Select a group type to be used in the progressive configurations
            </label>
            <Components.ButtonSelector
                items={[
                    { label: "Terminal", value: "terminal" },
                    { label: "Game", value: "game" }
                ]}
                columnClass="col-6"
                selectedClass="selected-button"
                notSelectedClass="not-selected-button"
                value={[props.chosenType]}
                onChange={props.onSelectItem}
            />
        </div>
    );
};

SectionHeader.defaultProps = {
    chosenType: ""
};

export default SectionHeader;
